import { faCancel, faClose, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const FilterButtons = ({handleFilterSearch,handleFilterCancle,handleFilterClose}) => {
    return (
        <div className="mt-2 float-end">
            <button onClick={handleFilterSearch} className="btn btn-sm btn-primary data-submit me-sm-2 me-1 waves-effect waves-light">Search&nbsp;<FontAwesomeIcon icon={faSearch} /></button>
            <button onClick={handleFilterCancle} type="reset" className="btn btn-sm btn-danger waves-effect" >Cancel Filter &nbsp;<FontAwesomeIcon icon={faCancel} /></button>
            {/* <button onClick={handleFilterClose} type="reset" className="btn btn-sm btn-secondary waves-effect" >Close Filter &nbsp;<FontAwesomeIcon icon={faClose} /></button> */}
        </div>
    )
}

export default FilterButtons
